import { Repos } from '@src/containers/Blotters/OTC/Repos/Repos';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { ReposBlotterPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function ReposPanel({ params, api }: LayoutPanelProps<ReposBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.ReposBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="repos-panel"
      >
        <Repos />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
